import React from "react";

export function MergingList({ mergingList = {} }) {
  return (
    <>
      <div className="row">
        <div className="col row">
          <div className="col-lg-3">
            <b>No Donasi</b>
          </div>
          <div className="col-lg-1">:</div>
          <div className="col-lg-7">
            <b>{mergingList.donation && mergingList.donation.donation_hid}</b>
          </div>
        </div>
        <div className="col row">
          <div className="col-lg-3">
            <b>Atas Nama</b>
          </div>
          <div className="col-lg-1">:</div>
          <div className="col-lg-7">
            <b>{mergingList.donation && mergingList.name_1}</b>
          </div>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col row">
          <div className="col-lg-3">
            <b>Nama Hewan</b>
          </div>
          <div className="col-lg-1">:</div>
          <div className="col-lg-7">
            <b>{mergingList.donation && mergingList.thk_livestock_name}</b>
          </div>
        </div>
        <div className="col row">
          {/* <div className="col-lg-3">
            <b>No Donasi</b>
          </div>
          <div className="col-lg-1">:</div>
          <div className="col-lg-7">
            <b>{mergingList.donation && mergingList.donation.donation_hid}</b>
          </div> */}
        </div>
      </div>
    </>
  );
}
